// @ts-nocheck
import { capitalize } from 'lodash';
import React from 'react';
import { useIntl } from 'react-intl';
import { BoxV2, ButtonUI, Checkbox, MultipleTagSelector } from 'sonata-react-components';

import { ColumnOptionsStyle } from './ColumnOptions.styles';

import type { Columns } from '../types';

type Props = {
  id: string;
  isAddressToLocations?: boolean;
  isCoordinatesToLocations?: boolean;
  onAddressToLocations?: (val: boolean) => void;
  onColumnsSelectedChange: (columns: Columns[]) => void;
  onCoordinatesToLocations?: (val: boolean) => void;
  stats: Columns[];
};

function ColumnOptions({
  id,
  isAddressToLocations = false,
  isCoordinatesToLocations = false,
  onAddressToLocations,
  onColumnsSelectedChange,
  onCoordinatesToLocations,
  stats
}: Props) {
  const { formatMessage } = useIntl();

  const selectedIds = stats.filter(item => item.visible).map(item => item.prop);

  const capitalizeStat = (text: string) => {
    const res = capitalize(text);
    if (res.indexOf('_') > -1) {
      return res
        .split('_')
        .map(i => capitalize(i))
        .join('');
    }
    return res;
  };

  const formatColumns = [
    {
      id: 'metrics',
      items: stats.map(item => ({
        label:
          item.cpy ||
          formatMessage({
            defaultMessage: item.prop,
            id: `columnOptions.stats.cpyTable${capitalizeStat(item.prop)}`
          }),
        value: item.prop
      })),
      title: formatMessage({
        defaultMessage: 'Metrics',
        id: 'columnOptions.metrics'
      })
    }
  ];

  const handleColumnsSelectedChange = (values: string[]) => {
    const cols = stats.map(item => ({
      ...item,
      visible: values.includes(item.prop)
    }));
    onColumnsSelectedChange(cols);
  };

  return (
    <ColumnOptionsStyle className="columnOptions" id={id}>
      <BoxV2.Header bgColor="transparent" expandablePosition="left" isExpandable padding="0">
        <BoxV2.Header.Title
          title={formatMessage({
            defaultMessage: 'Column Options',
            id: 'columnOptions.title'
          })}
          titleFontStyles="columnOptions__title"
        />
      </BoxV2.Header>
      <BoxV2.Body bgColor="transparent" padding="0">
        <div className="columnOptions__clear">
          <ButtonUI
            disabled={selectedIds.length === 0}
            icon="far fa-trash"
            onClick={() => handleColumnsSelectedChange([])}
            shape="link"
            size="small"
            text={formatMessage({
              defaultMessage: 'Clear All',
              id: 'columnOptions.clear'
            })}
            type="secondary"
          />
        </div>
        {formatColumns.map(column => (
          <div className="columnOptions__multipleTag" key={column.id}>
            <span className="columnOptions__multipleTagTitle">{column.title}</span>
            <MultipleTagSelector
              className="columnOptions__multipleTagSelector"
              items={column.items}
              mark
              onChange={ids => handleColumnsSelectedChange(ids)}
              selectedItems={selectedIds}
            />
          </div>
        ))}
        <div className="columnOptions__settingsTitle">
          {formatMessage({
            defaultMessage: 'Other Settings',
            id: 'columnOptions.other'
          })}
        </div>
        <div className="columnOptions__settings">
          <div className="columnOptions__settingsContainer">
            <Checkbox
              active={isCoordinatesToLocations}
              id="addLatLng"
              onClickAction={(_id: string, checked: boolean) => onCoordinatesToLocations?.(checked)}
              tiny
            />
            <div className="columnOptions__settingsLabel">
              {formatMessage({
                defaultMessage: 'Add',
                id: 'common.add'
              })}
              <span className="columnOptions__settingsLabelBold">
                {formatMessage({
                  defaultMessage: 'Latitude & Longitude',
                  id: 'columnOptions.checks.latLng'
                })}
              </span>
              {formatMessage({
                defaultMessage: 'to Locations',
                id: 'columnOptions.checks.to'
              })}
            </div>
          </div>
          <div className="columnOptions__settingsContainer">
            <Checkbox
              active={isAddressToLocations}
              id="addAddress"
              onClickAction={(_id: string, checked: boolean) => onAddressToLocations?.(checked)}
              tiny
            />
            <div className="columnOptions__settingsLabel">
              {formatMessage({
                defaultMessage: 'Add',
                id: 'common.add'
              })}
              <span className="columnOptions__settingsLabelBold">
                {formatMessage({
                  defaultMessage: 'Address info',
                  id: 'columnOptions.checks.address'
                })}
              </span>
              {formatMessage({
                defaultMessage: 'to Locations',
                id: 'columnOptions.checks.to'
              })}
            </div>
          </div>
        </div>
      </BoxV2.Body>
    </ColumnOptionsStyle>
  );
}

export default ColumnOptions;
